import { render, staticRenderFns } from "./SubscriptionTab.vue?vue&type=template&id=68b78859&scoped=true"
import script from "./SubscriptionTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b78859",
  null
  
)

export default component.exports